var map = {
	"./": 137,
	"./Clutch": 2655,
	"./Clutch.js": 2655,
	"./NewUi": 2656,
	"./NewUi.js": 2656,
	"./OldUi": 2657,
	"./OldUi.js": 2657,
	"./index": 137,
	"./index.js": 137,
	"./style": 853,
	"./style.js": 853
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4166;